export default __webpack_public_path__ + "static/datelabel-dropdown-do-2-light-3b4895878eb0c99bfe8a9a1cd260c23a6ec2bb235cd856151888be423f88f577.png";